import type { RequestFn } from '../http';
import type { OSRMOutboundResult, OSRMReturnResult } from '../types';

export function createOsrmApi(request: RequestFn) {
  return {
    async calculateOutboundRoute(data: {
      departureLocation: 'HOME' | 'OFFICE' | 'CUSTOMER' | 'CUSTOM';
      departureAddress?: string;
      customerAddress: string;
      technicianHomeAddress?: string;
    }) {
      return request<OSRMOutboundResult>('/osrm/outbound', {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },

    async calculateReturnRoute(data: {
      customerAddress: string;
      nextDestination: 'HOME' | 'OFFICE' | 'CUSTOMER' | 'PRIVATE' | 'CUSTOM';
      nextDestinationAddress?: string;
      technicianHomeAddress?: string;
    }) {
      return request<OSRMReturnResult>('/osrm/return', {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },

    async geocodeAddress(address: string) {
      return request<{ lat: number; lon: number; address: string }>('/osrm/geocode', {
        method: 'POST',
        body: JSON.stringify({ address }),
      });
    },

    async reverseGeocode(lat: number, lon: number) {
      return request<{ address: string; displayName: string; lat: number; lon: number }>(
        '/routing/reverse-geocode',
        {
          method: 'POST',
          body: JSON.stringify({ lat, lon }),
        }
      );
    },

    async calculateRoute(data: { startAddress: string; endAddress: string }) {
      return request<{
        distanceKm: number;
        durationMinutes: number;
        meta?: {
          provider: string;
          profile: string;
        };
      }>('/routing/route-by-address', {
        method: 'POST',
        body: JSON.stringify(data),
      }).then((res) => ({
        distanceKm: (res as { km?: number; distanceKm?: number }).km ?? res.distanceKm,
        durationMinutes:
          (res as { minutes?: number; durationMinutes?: number }).minutes ??
          res.durationMinutes,
        meta: res.meta,
      }));
    },
  };
}
